import { render, staticRenderFns } from "./OrderableProductBundle.vue?vue&type=template&id=3cfc870b&"
import script from "./OrderableProductBundle.vue?vue&type=script&lang=ts&"
export * from "./OrderableProductBundle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports